const translations = {
  'login': 'Login',
  'logOut': 'Sign out',
  'email': 'Email',
  'password': 'Password',
  'code': 'code'
}

export default translations;
